<template>
  <LayoutContent>
    <SectionTitle :label="$t('label.myAppointments')" />
    <v-container>
      <v-tabs class="agent-tab--wrapper mb-4" slider-color="primary darken-1" v-model="currentTab" centered @change="onTabChange">
        <v-tab class="text-capitalize text-subtitle-1 text-center font-weight-bold tab" active-class="primary--text text--darken-1" v-for="tab in tabs" :key="tab.name">{{ tab.name }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="currentTab" class="appointments-tab-bg">
        <v-tab-item v-for="tab in tabs" :key="tab.name">
          <AppointmentsTab :appointmentType="tab.type" :key="tab.type" />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </LayoutContent>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import AppointmentsTab from '@/components/appointment/AppointmentsTab.vue'
import { AppointmentType } from '@/constants/enums'
import { localeHelper } from '@/utils'

export default {
  name: 'MyAppointment',
  components: {
    SectionTitle,
    LayoutContent,
    AppointmentsTab
  },

  data() {
    return {
      currentTab: 'current',
      tabs: [
        {
          key: 'upcoming',
          type: AppointmentType.UPCOMING,
          name: localeHelper.getMessage('label.upcoming')
        },
        {
          key: 'past',
          type: AppointmentType.PAST,
          name: localeHelper.getMessage('label.history')
        }
      ]
    }
  },
  created() {
    this.currentTab = this.tabs.findIndex((f) => f.key === this.$route.query.tab)
  },
  methods: {
    onTabChange(tabIndex) {
      this.$router.replace({ name: this.$constants.ROUTE_NAME.APPOINTMENT_MY_APPOINTMENT, query: { tab: this.tabs[tabIndex].key } })
    }
  }
}
</script>

<style lang="scss">
.agent-tab--wrapper.agent-tab--wrapper.agent-tab--wrapper > .v-tabs-bar {
  background-color: transparent;
  margin-bottom: 2rem;
}

.appointments-tab--wrapper {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 2rem;
  row-gap: 1.5rem;

  @media only screen and (min-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }
}
.appointments-tab-bg {
  background-color: var(--v-secondary-lighten6) !important;
}
.tab {
  width: 50%;
}
</style>
